import ReactDOM from "react-dom/client"

import App from "./App"
import reportWebVitals from "./reportWebVitals"

/* CSS */
import "./design/css/app.css"
import "./design/css/preloader.css"
import "./design/css/game.css"
import "./design/css/chips.css"
import "./design/css/chip.css"
import "./design/css/rates.css"
import "./design/css/card.css"
import "./design/css/result.css"
import "./design/css/timer.css"
import "./design/css/payout.css"
import "./design/css/history.css"
import "./design/css/roads.css"
import "./design/css/rules.css"

/* Fields */
const pathname = window.location.search
const token = pathname.length > 1 ? pathname.substring(1) : ""

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(token.length > 64 ? <App /> : <div className="page-404"><span>404</span> Page not found</div>)

reportWebVitals()